import { render, staticRenderFns } from "./ViewAwards.vue?vue&type=template&id=a684a6a4"
import script from "./ViewAwards.vue?vue&type=script&lang=js"
export * from "./ViewAwards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports